import React, { useEffect, useState } from 'react'

const AppFooter = () => {
  const [year, setYear] = useState([])
  useEffect(() => {
    const today = new Date()
    setYear(today.getFullYear())
  }, [])
  return (
    <>
      <footer className="main-footer">
        <strong>Copyright &copy; {year} <a target="_blank" href="https://devnestforge.com" rel="noreferrer">Devnestforge</a></strong>
        <div className="float-right d-none d-sm-inline-block">
          <b>Version</b> 1.0
        </div>
      </footer>

      <aside className="control-sidebar control-sidebar-dark">
      </aside>
    </>
  )
}

export default AppFooter
